import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import NotificationListComponent from "../components/notification/NotificationListComponent";
import NotificationFormComponent from "../components/notification/NotificationFormComponent";

const NotificationPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('notifications') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  return (
    <div className="NotificationPage p-component p-m-lg-4">
      <Panel>
        <NotificationListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/notification');
               }}>
        <NotificationFormComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(NotificationPage);
